// ============================================================
//  src/components/layout/PageHeader.js
// ============================================================
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PageHeader.css';

export default function PageHeader({ title, backTo, icon, action }) {
  const navigate = useNavigate();
  const handleBack = () => (backTo ? navigate(backTo) : navigate(-1));

  return (
    <div className="page-hdr">
      <button className="page-hdr-back" onClick={handleBack}>
        <i className="fas fa-arrow-left" />
      </button>
      <div className="page-hdr-title">
        {icon && <i className={`fas ${icon} page-hdr-icon`} />}
        <h2>{title}</h2>
      </div>
      <div className="page-hdr-action">
        {action || <span />}
      </div>
    </div>
  );
}
